import { ContextMenu } from 'cpool-components/general/ContextMenu';
import { LOAN_REQUEST_OFFER_STATUS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetAcceptedOffers } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { HiOutlineDotsVertical } from 'react-icons/hi';

import { TransferDocumentsDialog } from './TransferDocumentsDialog';
import { useOfferActions } from './useOfferActions';

type Props = {
    acceptedOffer: SchemaLoanRequestResolver_GetAcceptedOffers[number];
    onOpenConsorsNotes: () => void;
    onOpenOfferEmailDialog: (offerId: string) => void;
};

export const MoreActionsMenu: React.FC<Props> = ({ acceptedOffer, onOpenConsorsNotes, onOpenOfferEmailDialog }) => {
    const { t } = useTranslation();
    const {
        acknowledgedDocuments,
        closeTransferDialog,
        hasNewConsorsNotes,
        isTransferDialogOpen,
        items,
        transferDocumentsToBank,
    } = useOfferActions({ acceptedOffer, onOpenConsorsNotes, onOpenOfferEmailDialog });

    const isOfferCancelledOrExpired =
        acceptedOffer.status === LOAN_REQUEST_OFFER_STATUS.CANCELLED ||
        acceptedOffer.status === LOAN_REQUEST_OFFER_STATUS.OFFER_EXPIRED;
    const showAlertBadge = hasNewConsorsNotes && !isOfferCancelledOrExpired;

    return (
        <>
            <ContextMenu
                items={items}
                eventStopPropagation
                triggerAriaLabel={t('OFFER_MANAGEMENT.MORE_ACTIONS')}
                trigger={
                    <button
                        type="button"
                        data-testid="more-actions-menu-button"
                        className="relative flex items-center justify-center p-1.5 rounded text-midnight hover:bg-surface-light transition-colors"
                    >
                        {showAlertBadge && (
                            <span className="absolute top-0 right-0 bg-alert-error text-white text-10 rounded-full w-4 h-4 flex items-center justify-center">
                                1
                            </span>
                        )}
                        <HiOutlineDotsVertical size={16} />
                    </button>
                }
            />
            <TransferDocumentsDialog
                documentNames={acknowledgedDocuments.map((document) => document.name)}
                open={isTransferDialogOpen}
                onClose={closeTransferDialog}
                onConfirm={transferDocumentsToBank}
            />
        </>
    );
};
